import { useEffect, useState } from 'react'
import { Label } from 'semantic-ui-react'

const _styles = {
  header: {
    display: "grid",
    gridTemplateColumns: "1fr auto 1fr",
    gap: 8,
    padding: '1em',
  },
  teamLabel: () => ({
    // fontSize: 12,
    textAlign: 'center',
    fontWeight: 'bold'
  }),
  // Popup
  overlay: {
    position: "fixed",
    inset: 0,
    background: 'var(--off-black-1)',
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 100,
    backdropFilter: "blur(4px)",
  },
  popup: {
    background: 'var(--off-black-3)',
    border: "1px solid #2a2a2a",
    borderRadius: 16,
    width: '90%',
    overflow: "hidden",
  },
  popupHeader: {
    display: "grid",
    gridTemplateColumns: "1fr auto 1fr",
    alignItems: "center",
    gap: 8,
    padding: "16px 20px 12px",
    borderBottom: "1px solid #1e1e1e",
  },
  popupScore: () => ({
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: 'var(--sem-blue)',
    borderRadius: 8,
    fontSize: 32,
    letterSpacing: 2,
    color: 'var(--off-white-1)',
    minWidth: 70,
  }),
  keypad: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 6,
    padding: "8px 16px 0",
  },
  key: {
    height: 52,
    background: "#1e1e1e",
    border: "1px solid #2a2a2a",
    borderRadius: 10,
    cursor: "pointer",
    fontSize: 24,
    color: "#e0e0e0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.1s",
  },
  actions: { display: "grid", gridTemplateRows: "1fr 1fr", gridTemplateColumns: "1fr 1fr", gap: 8, padding: "12px 16px 16px" },
  btnClear: {
    height: 44,
    background: 'var(--off-black-4)',
    border: "1px solid #2a2a2a",
    borderRadius: 10,
    cursor: "pointer",
    fontSize: 12,
    color: 'var(--off-white-1)',
    textTransform: "uppercase",
  },
  btnUpdate: (disabled) => ({
    height: 44,
    background: disabled ? 'var(--off-black-3)' : 'var(--sem-blue)',
    border: "none",
    borderRadius: 10,
    cursor: disabled ? "not-allowed" : "pointer",
    fontSize: 12,
    color: 'var(--off-white-1)',
    textTransform: "uppercase",
    fontWeight: 500,
    opacity: disabled ? 0.4 : 1,
    transition: "all 0.15s",
  }),
};

const KeyPadSimple = ({ setIndex, currentMatch, matchSet, onUpdate, onClose, onCloseNext }) => {

  const { home, away, _status } = currentMatch ?? {}
  const { name: homeTeam } = home ?? {}
  const { name: awayTeam } = away ?? {}

  const _setIndex = setIndex + 1

  const initInput = () => {
    if (matchSet.away !== null && matchSet.home !== null) {
      return [
        Math.floor(matchSet.away / 10),
        matchSet.away % 10,
        Math.floor(matchSet.home / 10),
        matchSet.home % 10,
      ];
    }
    return [];
  };

  const [input, setInput] = useState(initInput());

  // Save route on every change
  useEffect(() => {
    setInput(initInput())
  }, [matchSet]);

  const handleKey = (n) => {
    if (input.length >= 4) return;
    setInput((prev) => [...prev, n]);
  };

  const handleBack = () => setInput((prev) => prev.slice(0, -1));

  const handleClear = () => {
    setInput([]);
  };

  const handleRemove = () => {
    onUpdate(setIndex, null, null);
    onClose();
  };

  const handleUpdate = () => {
    if (input.length < 4) return;
    const away = input[0] * 10 + input[1];
    const home = input[2] * 10 + input[3];
    onUpdate(setIndex, away, home);
    onClose();
  };

  const handleUpdateNext = () => {
    if (input.length < 4) return;
    const away = input[0] * 10 + input[1];
    const home = input[2] * 10 + input[3];
    onUpdate(setIndex, away, home);
    onCloseNext();
  };

  const step = input.length;

  const awayStr =
    input[0] !== undefined
      ? input[0] + (input[1] !== undefined ? String(input[1]) : "_")
      : "__";
  const homeStr =
    input[2] !== undefined
      ? input[2] + (input[3] !== undefined ? String(input[3]) : "_")
      : "__";

  const dotState = (i) => {
    if (i < step) return i < 2 ? "done-away" : "done-home";
    if (i === step) return i < 2 ? "active-away" : "active-home";
    return "idle";
  };

  return (
    <div style={_styles.overlay} onClick={(e) => e.target === e.currentTarget && onClose()}>

      <div style={_styles.popup}>
        <div style={_styles.header}>
          <div style={_styles.teamLabel()}>{awayTeam}</div>
          <div>vs</div>
          <div style={_styles.teamLabel()}>{homeTeam}</div>
        </div>
        {/* Header */}
        <div style={_styles.popupHeader}>

          <div style={_styles.popupScore()}>{awayStr}</div>
          <Label size='large'>{`Set ${_setIndex}`}</Label>
          <div style={_styles.popupScore()}>{homeStr}</div>
        </div>

        {/* Keypad */}
        <div style={_styles.keypad}>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
            <button key={n} style={_styles.key} onClick={() => handleKey(n)}>
              {n}
            </button>
          ))}
          {/* empty left cell, 0 center, backspace right */}
          <div />
          <button style={_styles.key} onClick={() => handleKey(0)}>0</button>
          <button style={{ ..._styles.key, color: "#666", fontSize: 18 }} onClick={handleBack}>⌫</button>
        </div>

        {/* Actions */}
        <div style={_styles.actions}>
          <button style={_styles.btnClear} onClick={handleRemove}>Remove</button>
          <button style={_styles.btnClear} onClick={handleClear}>Clear</button>
          <button style={_styles.btnClear} onClick={onClose}>Close</button>
          <button style={_styles.btnUpdate(input.length < 4)} onClick={handleUpdateNext} disabled={input.length < 4}>
            Update and Next
          </button>
          <button style={_styles.btnUpdate(input.length < 4)} onClick={handleUpdate} disabled={input.length < 4}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default KeyPadSimple
